const login = {
  brandTitle: 'Xceptional',
  brandSubtitle: 'Learning',
  brandTagline: 'भविष्यवादी · क्लिनिकल-ग्रेड · देखभालपूर्ण',
  heroTitle: 'हर शिक्षार्थी की<br />यात्रा को सशक्त बनाना',
  heroDescription: 'एक एकीकृत प्लेटफ़ॉर्म जो चिकित्सकों, शिक्षकों, समन्वयकों और परिवारों को जोड़ता है — बच्चे पर केंद्रित, कागज़ी कार्रवाई पर नहीं।',
  feature1Title: 'छात्र केसलोड प्रबंधन',
  feature1Sub: 'समग्र प्रोफ़ाइल और रिकॉर्ड',
  feature2Title: 'थेरेपी सत्र ट्रैकिंग',
  feature2Sub: 'नोट्स, आकलन और प्रगति',
  feature3Title: 'स्मार्ट शेड्यूलिंग',
  feature3Sub: 'स्वचालित विरोध पहचान',
  feature4Title: 'प्रगति विश्लेषण',
  feature4Sub: 'विकासात्मक डोमेन अंतर्दृष्टि',
  trustAccessible: 'WCAG-AA सुलभ',
  trustEncrypted: 'एंड-टू-एंड एन्क्रिप्टेड',
  trustNDIS: 'NDIS संरेखित',
  welcomeBack: 'वापसी पर स्वागत है',
  signInSubtitle: 'अपने Xceptional Learning खाते में साइन इन करें',
  signInAs: 'के रूप में साइन इन करें',
  signIn: 'साइन इन',
  signingIn: 'साइन इन हो रहा है…',
  enterPassword: 'अपना पासवर्ड दर्ज करें',
  forgotPassword: 'पासवर्ड भूल गए?',
  demoCredentials: 'डेमो क्रेडेंशियल',
  tryDemoTitle: 'डेमो आज़माएं',
  tryDemoDescription: 'प्लेटफ़ॉर्म का अन्वेषण करने के लिए किसी भी ईमेल + पासवर्ड (न्यूनतम 6 अक्षर) का उपयोग करें।',
  resetPasswordTitle: 'अपना पासवर्ड रीसेट करें',
  resetPasswordDescription: 'अपना खाता ईमेल दर्ज करें और हम आपको एक सुरक्षित रीसेट लिंक भेजेंगे।',
  sendResetLink: 'रीसेट लिंक भेजें',
  backToSignIn: 'साइन इन पर वापस जाएं',
  emailSentTitle: 'ईमेल भेज दिया गया!',
  emailSentDescription: 'रीसेट लिंक के लिए अपना इनबॉक्स जांचें। रीडायरेक्ट हो रहा है…',
  emailRequired: 'ईमेल पता आवश्यक है',
  emailInvalid: 'कृपया एक मान्य ईमेल पता दर्ज करें',
  passwordRequired: 'पासवर्ड आवश्यक है',
  passwordMinLength: 'पासवर्ड कम से कम 6 अक्षर का होना चाहिए',
  roleAdmin: 'एडमिन',
  roleCoordinator: 'समन्वयक',
  roleTherapist: 'थेरेपिस्ट',
  roleTeacher: 'शिक्षक',
  privacyPolicy: 'गोपनीयता नीति',
  termsOfService: 'सेवा की शर्तें',
};

export default login;